import { createFileRoute } from '@tanstack/react-router';
import VerificationPage from '../pages/VerificationPage';

export const Route = createFileRoute('/verification')({
    component: VerificationPage,
});